import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UsersService } from "./users.service";
import { PersonsService } from "./persons.service";
import { PublicPersonsService } from "./public/persons.service";
import { CreditBehaviorService } from "./credit-behavior.service";
import { TokyService } from "./toky.service";
import { FollowUpService } from "./followup.service";
import { SafeguardingProcessProcessService } from "./safeguarding-process.service";
import { DeliveryProcessService } from "./delivery-process.service";
import { ContactsService } from "./contacts.service";
import { PublicContactsService } from "./public/contacts.service";
import { ContractService } from "./contract.service";
import { MarcaService } from "./marca.service";
import { PublicMarcaService } from "./public/marca.service";
import { OpportunitiesService } from "./opportunities.service";
import { ImagesService } from "./images.service";
import { CreditHistoryService } from "./credit-history.service";
import { PublicCreditHistoryService } from "./public/credit-history.service";
import { LeasingService } from "./leasing.service";
import { PublicLeasingService } from "./public/leasing.service";
import { DocumentsService } from "./documents.service";
import { PublicDocumentsService } from "./public/documents.service";
import { ReasonInactiveService } from "./reason-inactive.service";
import { InsuranceService } from "./insurance.service";
import { PublicInsuranceService } from "./public/insurance.service";
import { AccountsService } from "./accounts.service";
import { PublicAccountsService } from "./public/accounts.service";
import { GpsService } from "./gps.service";
import { ValidationProcessService } from "./validation-process.service";
import { PublicValidationProcessService } from "./public/validation-process.service";
import { SitingService } from "./siting-state.service";
import { OpenBankingService } from "./open-banking.service";
import { PublicOpenBankingService } from "./public/open-banking.service";
import { ConstantsService } from "./constants.service";
import { ApplicationsService } from "./applications.service";
import { PublicApplicationsService } from "./public/applications.service";
import { PlateService } from "./plate.service";
import { PaymentPlanService } from "./payment-plan.service";
import { AccountModificationsService } from "./account-modifications.service";
import { QuotesService } from "./quotes.service";
import { PublicQuotesService } from "./public/quotes.service";
import { PaymentsService } from "./payments.service";
import { PurchaseOrdersService } from "./purchase-orders.service";
import { NetCashService } from "./net-cash.service";
import { CheckForUpdateService } from "./check-for-updates.service";
import { MailerService } from "./mailer.service";
import { CommentsService } from "./comments.service";
import { PublicCommentsService } from "./public/comments.service";
import { TicketsService } from "./tickets.service";
import { VisitsService } from "./visits.service";
import { PublicVisitsService } from "./public/visits.service";
import { ReferralsService } from "./referrals.service";
import { PublicReferralsService } from "./public/referrals.service";
import { GeolocationService } from "./geolocation.service";
import { PublicGeolocationService } from "./public/geolocation.service";
import { EmailService } from "./email.service";
import { PublicMailerService } from "./public/mailer.service";
import { PaybookService } from "./paybook.service";
import { TeamService } from "./team.service";
import { TrackerService } from "./tracker.service";
import { GoalsService } from "./goals.service";
import { WorkflowsService } from "./workflow.service";
import { ProvidersService } from "./providers.service";
import { DisbursementsService } from "./disbursements.service";
import { DealershipsService } from "./dealerships.service";
import { CommissionSchemesService } from "./commission-scheme.service";
import { CommissionDiscountService } from "./commission-discount.service";
import { CommissionSummariesService } from "./commission-summary.service";
import { CommissionPaymentService } from "./commission-payment.service";
import { ContributionsService } from "./contributions.service";
import { BanksService } from "./banks.service";
import { DownpaymentsService } from "./downpayments.service";
import { NavigationService } from "./navigation.service";
import { DocumentValidationService } from "./document-validation.service";
import { DocumentProofService } from "./document-proof.service";
import { DocumentSecurityLockService } from "./document-security-lock.service";
import { EstadosService } from "./estados.service";
import { PhoneNumberService } from "./phone_numbers.service";
import { PlatesProcessService } from "./plates-process.service";
import { SimpleAddressService } from "./simple-address.service";
import { ContractVisitsService } from "./contract_visits.service";
import { JobInformationService } from "./job-information.service";
import { ReferencesService } from "./references.service";
import { PublicReferencesService } from "./public/references.service";
import { AmortizationService } from "./amortization.service";
import { DealershipGroupService } from "./dealership-groups.service";
import { QuestionsService } from "./questions.service";
import { BankAccountsService } from "./bank_accounts.service";
import { InvoiceInformationService } from "./invoice_information.service";
import { FacturamaService } from "./facturama.service";
import { ProductRequestService } from "./product-request.service";
import { ImssService } from "./imss.service";
import { PublicImssService } from "./public/imss.service";
import { IsssteService } from "./issste.service";
import { OrdasService } from "./ordas.service";
import { InterService } from "./inter.service";
import { EikosService } from "./eikos.service";
import { InteresseInsuranceService } from "./interesse-insurance.service";
import { MarshService } from "./marsh.service";
import { DeliveryCarService } from "./delivery-car.service";
import { VehicleService } from "./vehicle.service";
import { DataClipService } from "./dataclip.service";
import { DomiciliationProcessService } from "./domiciliation-process.service";
import { StpService } from "./stp.service";
import { WebhooksService } from "./webhooks.service";
import { PublicWebhooksService } from "./public/webhooks.service";
import { DomiPaymentsService } from "./domi-payments.service";
import { PublicLeadOnboardingService } from "./public/lead-onboarding.service";
import { IncodeService } from "./incode.service";
import { StatementsService } from "./statements.service";
import { EarlySettlementsService } from "./early_settlements.service";
import { PublicEarlySettlementsService } from "./public/early-settlements.service";
import { InsuranceConciliationService } from "./insurance-conciliation.service";
import { DealershipsUsersService } from "./dealerships-users.service";
import { PublicClientService } from "./public/client.service";
import { PublicContractService } from "./public/contract.service";
import { PublicContractVisitsService } from "./public/contract_visits.service";
import { PublicGpsService } from "./public/gps.service";
import { PublicHttpClientService } from "./public/http-client.service";
import { PublicTicketsService } from "./public/tickets.service";
import { ExternalSalesmanCardService } from "./public/external-salesman-card.service";
import { ExternalSalesmanCardsService } from "./external-salesman-cards.service";
import { CardCommissionDepositsService } from "./card-commission-deposits.service";
import { ClosureService } from "./closure.service";
import { VehicleRepossessionService } from "./vehicle-repossession.service";
import { PaymentRowService } from "./payment-row.service";
import { BrokersService } from "./brokers.service";
import { VersionsService } from "./versions.service";
import { AgreementsService } from "./agreements.service";
import { SubsidiesService } from "./subsidies.service";
import { BillingService } from "./billing.service";
import { ProceduresService } from "./procedures.service";
import { PlatesPaymentRequestsService } from "./plates-payment-requests.service";
import { VideoVerificationSessionsService } from "./video-verification-sessions.service";
import { PublicVideoVerificationSessionsService } from "./public/video-verification-sessions.service";
import { FullScreenLoaderService } from "./public/full-screen-loader.service";
import { MetabaseService } from "./metabase.service";
import { EstimatedIncomesService } from "./estimated-incomes.service";
import { CurpOrchestratorService } from "./curp.service";
import { RiskValidationService } from "./risk-validation.service";
import { PlatformService } from "./public/platform.service";
import { DisbursementsAccessoriesService } from "./disbursements-accessories.service";
import { InsuranceProcessService } from "./insurance-process.service";
import { PublicStatementsService } from "./public/statements.service";
import { ProcessesService } from "./processes.service";
import { PreventiveCollectionService } from "./preventive-collection.service";
import { KycProfileService } from "./kyc-profile.service";
import { OnboardingProgressService } from "./onboarding-progress.service";
import { LeadPrioritizationService } from "./lead-prioritization.service";
import { EndorsementCallsService } from "./endorsement_calls.service";
import { ExternalQuotesService } from "./external-quotes.service";
import { BotmakerService } from "./botmaker.service";

@NgModule({
  imports: [CommonModule],
  providers: [
    UsersService,
    CreditBehaviorService,
    TokyService,
    FollowUpService,
    SafeguardingProcessProcessService,
    DeliveryProcessService,
    ContactsService,
    PublicContactsService,
    PersonsService,
    PublicPersonsService,
    MarcaService,
    PublicMarcaService,
    OpportunitiesService,
    ImagesService,
    CreditHistoryService,
    PublicCreditHistoryService,
    LeasingService,
    PublicLeasingService,
    DocumentsService,
    PublicDocumentsService,
    ReasonInactiveService,
    ContractService,
    InsuranceService,
    PublicInsuranceService,
    AccountsService,
    PublicAccountsService,
    GpsService,
    ValidationProcessService,
    PublicValidationProcessService,
    SitingService,
    OpenBankingService,
    PublicOpenBankingService,
    ConstantsService,
    ApplicationsService,
    PublicApplicationsService,
    PlateService,
    PaymentPlanService,
    AccountModificationsService,
    QuotesService,
    PublicQuotesService,
    PaymentsService,
    PurchaseOrdersService,
    NetCashService,
    CheckForUpdateService,
    MailerService,
    CommentsService,
    PublicCommentsService,
    TicketsService,
    VisitsService,
    PublicVisitsService,
    ReferralsService,
    PublicReferralsService,
    PublicReferencesService,
    GeolocationService,
    PublicGeolocationService,
    EmailService,
    PublicMailerService,
    TeamService,
    CommentsService,
    TicketsService,
    PaybookService,
    TrackerService,
    GoalsService,
    WorkflowsService,
    ProvidersService,
    DisbursementsService,
    DisbursementsAccessoriesService,
    DealershipsService,
    CommissionSchemesService,
    CommissionDiscountService,
    CommissionSummariesService,
    CommissionPaymentService,
    ContributionsService,
    BanksService,
    DownpaymentsService,
    NavigationService,
    DocumentValidationService,
    DocumentProofService,
    DocumentSecurityLockService,
    EstadosService,
    PhoneNumberService,
    PlatesProcessService,
    SimpleAddressService,
    ContractVisitsService,
    JobInformationService,
    ReferencesService,
    DealershipGroupService,
    AmortizationService,
    QuestionsService,
    BankAccountsService,
    InvoiceInformationService,
    FacturamaService,
    ProductRequestService,
    ImssService,
    PublicImssService,
    IsssteService,
    OrdasService,
    InterService,
    EikosService,
    InteresseInsuranceService,
    MarshService,
    DeliveryCarService,
    VehicleService,
    DataClipService,
    DomiciliationProcessService,
    StpService,
    WebhooksService,
    PublicWebhooksService,
    DomiPaymentsService,
    PublicLeadOnboardingService,
    IncodeService,
    StatementsService,
    EarlySettlementsService,
    PublicEarlySettlementsService,
    InsuranceConciliationService,
    DealershipsUsersService,
    PublicClientService,
    PublicContractService,
    PublicContractVisitsService,
    PublicGpsService,
    PublicHttpClientService,
    PublicTicketsService,
    ExternalSalesmanCardService,
    ExternalSalesmanCardsService,
    CardCommissionDepositsService,
    ClosureService,
    VehicleRepossessionService,
    PaymentRowService,
    BrokersService,
    VersionsService,
    SubsidiesService,
    AgreementsService,
    BillingService,
    ProceduresService,
    PlatesPaymentRequestsService,
    VideoVerificationSessionsService,
    PublicVideoVerificationSessionsService,
    FullScreenLoaderService,
    MetabaseService,
    EstimatedIncomesService,
    CurpOrchestratorService,
    RiskValidationService,
    PlatformService,
    InsuranceProcessService,
    PublicStatementsService,
    ProcessesService,
    PreventiveCollectionService,
    KycProfileService,
    OnboardingProgressService,
    LeadPrioritizationService,
    EndorsementCallsService,
    ExternalQuotesService,
    BotmakerService,
  ],
})
export class ServicesModule {}
